module.exports = __webpack_public_path__ + "img/fangan4.218e0699.png";